import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../lib/cn";

/**
 * 16px ring, 1.5px border, brand arc on top — the design's loading indicator.
 *
 * `label` is required and rendered to screen readers only. A spinner with no
 * announcement leaves a non-sighted user with silence during exactly the
 * moment the interface is asking them to wait.
 */
export type SpinnerProps = Omit<HTMLAttributes<HTMLSpanElement>, "children"> & {
  label: string;
};

export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(
  function Spinner({ className, label, ...props }, ref) {
    return (
      <span ref={ref} role="status" className={cn("inline-flex", className)} {...props}>
        <span
          aria-hidden="true"
          className={cn(
            "size-4 rounded-full border-[1.5px] border-border2",
            "border-t-brand animate-spin-ring",
          )}
        />
        <span className="sr-only">{label}</span>
      </span>
    );
  },
);
